import React from "react";
import * as S from "./styles";
import { TaglineP } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";
import iconCloseWhite from "../../assets/icons/icon-close-white.png";

// Aceita colorBg/colorText (ListaProdutores) e color/textColor/icon (RankingReport)
// IsClose exibe o X branco a direita, para badge removivel (InputBadge); o clique
// chega em onClose ja com stopPropagation, porque a badge costuma ficar dentro de
// area clicavel (no InputBadge, clicar no campo abre o menu).
const Badge = ({ colorBg, colorText, color, textColor, icon, IsClose, onClose, closeTitle, children, ...props }) => {
  const handleClose = (event) => {
    event.stopPropagation();
    if (typeof onClose === "function") onClose(event);
  };

  return (
    <S.BadgeContainer colorBg={colorBg || color} hasClose={!!IsClose} {...props}>
      {icon && <img src={icon} alt="" width={12} />}
      
      <TaglineP color={colorText || textColor || theme.colors.white.Branco} fontWeight={800}>
        {children}
      </TaglineP>
      
      {IsClose && (
        <S.CloseButton type="button" title={closeTitle || "Remover"} onClick={handleClose}>
          <img src={iconCloseWhite} alt="" />
        </S.CloseButton>
      )}
    </S.BadgeContainer>
  );
};

export default Badge;
